import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import { CallSettings } from '../components/CallSettings/CallSettings';
import { DigitalAlertsSettings } from '../components/DigitalAlertsSettings/DigitalAlertsSettings';
import { KeywordSettings } from '../components/KeywordSettings/KeywordSettings';
import { TextMessagingSettings } from '../components/TextMessagingSettings/TextMessagingSettings';
import { persistor, SettingsManagementDispatch } from '../store';
import styles from './app.module.css';
import { initialize, selectAppSettingsState } from './appSlice';

const useInitialize = () => {
  const dispatch = useDispatch<SettingsManagementDispatch>();
  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);
};

const App = () => {
  const { initialized, initializing, initError } = useSelector(
    selectAppSettingsState,
  );
  useInitialize();
  return useMemo(() => {
    if (initError) {
      return <ErrorPage persistor={persistor} />;
    }

    if (initializing) {
      return <AppLoading />;
    }

    if (initialized) {
      return (
        <AppInnerWrapper>
          <h2 className={styles.title}>Notifications</h2>
          <div className={styles.description}>
            Configure agency-wide notification preferences for all incoming
            emergency traffic. Manage audio and visual notification settings to
            to customize how 911 calls, text sessions, and digital data are
            presented to agents.
          </div>
          <CallSettings />
          <TextMessagingSettings />
          <DigitalAlertsSettings />
          <KeywordSettings />
        </AppInnerWrapper>
      );
    }

    return <ErrorPage persistor={persistor} />;
  }, [initialized, initializing, initError]);
};

export default App;
